// extracted by mini-css-extract-plugin
export default {"hegLayout":"HegLayout_hegLayout__ETXJt","adsBackground":"HegLayout_adsBackground__dlDgC"};